import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import styles from "@website/ui/toggle-button/toggle-button.module.scss";
import { ToggleButtonPropertiesType } from "@website/ui/toggle-button/toggle-button.types";
import omit from "lodash-es/omit";
import { FC } from "react";
export const ToggleButton: FC<ToggleButtonPropertiesType> = properties => {
  const $ = _c(12);
  const {
    className,
    color: t0,
    disabled,
    loading,
    size: t1,
    variant: t2,
    list,
    value,
    onChange,
    lineDirection: t3,
    rounded: t4
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const size = t1 === undefined ? "medium" : t1;
  const variant = t2 === undefined ? "contained" : t2;
  const lineDirection = t3 === undefined ? "horizontal" : t3;
  const rounded = t4 === undefined ? false : t4;
  const t5 = `${styles.container} ${styles[lineDirection]} ${rounded ? styles.rounded : ""} ${className ?? ""}`;
  let t6;
  if ($[0] !== color || $[1] !== disabled || $[2] !== list || $[3] !== loading || $[4] !== onChange || $[5] !== size || $[6] !== value || $[7] !== variant) {
    t6 = loading ? <Loading color="white" size="sm" /> : <>{list.map(item => <Button key={item.value} {...omit(item, "id", "disabled", "color", "loading", "size", "variant", "fullWidth")} className={styles["btn-class-name"]} color={item.value === value ? color : "neutral"} disabled={disabled} onClick={() => onChange?.(item?.value || "")} replace={item?.replace} size={size} variant={item.value === value ? variant : "text"} />)}</>;
    $[0] = color;
    $[1] = disabled;
    $[2] = list;
    $[3] = loading;
    $[4] = onChange;
    $[5] = size;
    $[6] = value;
    $[7] = variant;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};